import { connect } from 'react-redux';
import _ from 'lodash';
import i18next from 'i18next';
import React from 'react';

import { DATE_PICKER_DOT_COLOR } from '@commons/DatePickers/constants';
import { Dropdown, INPUT_WIDTH, ToggleSwitch } from '@commons/utils/styledLibraryComponents';
import { SingleDatePicker } from '@commons/DatePickers/SingleDatePicker';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import {
  Container,
  DateContainer,
  LabelContainer,
  RestrictSupplierProductsContainer,
  ToggleContainer,
} from './styledComponents';

// Based on src/routes/backoffice/BackOfficeGeneralContainer/BackOfficeAnalytics/utils/modals.js
// Will be re-factored with https://deepsightprod.atlassian.net/browse/IPP-4592

const CreateInitialInventorySelectors = (props) => {
  const {
    // Date
    selectedDate,
    setSelectedDate,
    setFocusedMonth,
    forbiddenDates,
    // Stores
    stores,
    selectedStores,
    setSelectedStores,
    translatedStoreName,
    // Supplier Products
    supplierProducts,
    selectedSupplierProducts,
    setSelectedSupplierProducts,
    shouldRestrictSupplierProducts,
    setShouldRestrictSupplierProducts,
  } = props;

  const noStoresSelected = _.isEmpty(selectedStores);

  const CALENDAR_INFO = {
    dotsInformations: [
      {
        dotColor: DATE_PICKER_DOT_COLOR.RED,
        dotInfo: i18next.t('ORDERS.ORDERS.STOCK_FORM_DATEPICKER_TOOLTIP', { stockType: 'stock' }),
      },
    ],
  };

  return (
    <Container>
      <Dropdown
        customStyle={{ position: 'inherit' }}
        height={'64px'}
        isRequired={true}
        isUniqueSelection={false}
        items={stores}
        label={translatedStoreName}
        selectedItems={selectedStores}
        width={INPUT_WIDTH.LARGE}
        onSelectionChange={setSelectedStores}
      />
      <DateContainer>
        <LabelContainer>
          <Text
            color={noStoresSelected ? ENUM_COLORS.DARK : ENUM_COLORS.INFO_RED}
            font={ENUM_FONTS.TEXT_MIDDLE_NORMAL}
          >
            *
          </Text>
          <Text
            color={noStoresSelected ? ENUM_COLORS.DARK : ENUM_COLORS.DARKEST}
            font={ENUM_FONTS.TEXT_MIDDLE_NORMAL}
          >
            {i18next.t('GENERAL.DATE')}
          </Text>
        </LabelContainer>
        <SingleDatePicker
          calendarInfo={CALENDAR_INFO}
          customStyle={{ position: 'inherit' }}
          date={selectedDate}
          disabled={noStoresSelected}
          forbiddenDates={forbiddenDates}
          placeholder={i18next.t('GENERAL.DATEPICKER_PLACEHOLDER')}
          timezone="Europe/Paris" // TODO - [TIMEZONES] To be replaced by IPP-5227 Stock Module
          onDateChange={setSelectedDate}
          onNextMonthClick={(nextMonth) => setFocusedMonth(nextMonth)}
          onPrevMonthClick={(prevMonth) => setFocusedMonth(prevMonth)}
        ></SingleDatePicker>
      </DateContainer>
      <RestrictSupplierProductsContainer>
        <ToggleContainer>
          <ToggleSwitch
            checked={shouldRestrictSupplierProducts}
            disabled={noStoresSelected}
            handleClick={() => setShouldRestrictSupplierProducts(!shouldRestrictSupplierProducts)}
            id="restrict-supplier-products"
          />
          <Text
            color={noStoresSelected ? ENUM_COLORS.DARK : ENUM_COLORS.DARKEST}
            style={{ width: '200px' }}
          >
            {i18next.t('STOCKS.STOCKS.RESTRICT_SUPPLIER_PRODUCTS')}
          </Text>
        </ToggleContainer>
        <Dropdown
          customDropdownListStyle={{ maxHeight: '144px' }}
          customStyle={{ position: 'inherit' }}
          height={'64px'}
          isDisabled={!shouldRestrictSupplierProducts}
          isRequired={false}
          isUniqueSelection={false}
          items={supplierProducts}
          label={i18next.t('GENERAL.SUPPLIER_PRODUCT_PLURAL')}
          selectedItems={selectedSupplierProducts}
          width={INPUT_WIDTH.LARGE}
          largeDropdownList
          onSelectionChange={setSelectedSupplierProducts}
        />
      </RestrictSupplierProductsContainer>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: state.baseReducer.user,
});

export default connect(mapStateToProps)(CreateInitialInventorySelectors);
